module.exports = __webpack_public_path__ + "static/bg02-bbf5800ad29fb40f27c8aa5f6fe4abc3.png";